import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormModalService} from "../../../root/form-modal/form-modal.service";
import {EvaButtonGhost} from "../../../shared/eva-button-ghost/eva-button-ghost";
import {ModalService} from "../../../root/modal/modal.service";
import {ActivatedRoute} from '@angular/router';
import {SpecialSettingConfig} from "./special-setting";
import {Page} from "../../../shared/pager/page";
import {GAService} from "../../../root/ga/ga.service";
import {EvaMessage} from "../../../shared/eva-message/eva-message";
import {SessionService} from "../../../core/session.service";

@Component({
    selector: 'special-settings',
    providers: [GAService],
    templateUrl: './special-settings.component.html'
})

export class SpecialSettingsComponent implements OnChanges, OnInit{

    @Input() specialValues: any;
    @Input() pointsOfSale: any;
    @Output() removeSpecialSetting = new EventEmitter();
    @Output() updatePosRestriction:EventEmitter<any> = new EventEmitter<any>();

    specialConfig:SpecialSettingConfig = new SpecialSettingConfig();
    page: Page;

    name: string = "special-settings";
    title: string = "restrictions.SPECIAL_CONFIG.MODAL.title";
    addSpecialSettings:EvaButtonGhost;
    selectedSpecialValue;
    companyOid;
    openedModal;
    message:EvaMessage;

    //changes
    posListForSelect:any;

    constructor(private route:ActivatedRoute, private formModalService: FormModalService,
                private modalService: ModalService, private gaService:GAService,
                private session:SessionService){
        this.addSpecialSettings = new EvaButtonGhost('restrictions.SPECIAL_CONFIG.ADD', '', '-md');
        this.companyOid = route.snapshot.params['id'];
        this.message = new EvaMessage('common.NO_POS_ITEM_AVAILABLE', '', '-warning', 'warning');
    }

    ngOnInit(){
        this.posListForSelect = this.pointsOfSale.map(pos => {return {id:pos.oid, value:pos.name};});
    }

    ngOnChanges(changes: SimpleChanges){
        if(this.specialValues.length > 0){
            this.page = new Page(10, 1, this.specialValues.length, this.specialValues);
        }
    }

    openFormModal(value, type) {
        /*new empty instance*/
        if(type == "new"){
            this.selectedSpecialValue = new SpecialSettingConfig();
        }else{
            this.selectedSpecialValue = value;
            this.selectedSpecialValue.dateConfigRange =  (value.period.from == null && value.period.to == null) ? "date_always" : "date_range";
        }
        this.openedModal = true;
        this.gaService.notify("Autos_anticipación_duración", "Agregar_configuración_especial", ["Boton Agregar"]);
        this.formModalService.showFormModal(this.name, ()=>{
            this.sendOpen();
        });
    }

    sendOpen(){
        this.openedModal = false;
    }


    openModal(restriction) {
        //TODO customize title and description
        this.modalService.show('REMOVE_RESTRICTION_TITLE', 'REMOVE_RESTRICTION_MESSAGE', () =>  {
            //this.removeSpecialSetting.next();
            this.removeSpecialSetting.emit(restriction);
        });
    }

    savePosRestriction(item){
        this.updatePosRestriction.emit(item);
    }

    hideAddNewConfiguration(){
        return (this.pointsOfSale.length == 0 || !(this.session.loggedUserAllowed('PERM_RESTRICTIONS_CREATE')))
    }

    hideDeleteButton(){
        return !(this.session.loggedUserAllowed('PERM_RESTRICTIONS_DELETE'));
    };

    hideEditButton(){
        return !this.session.loggedUserAllowed('PERM_RESTRICTIONS_EDIT');
    }
}





// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/special-settings/special-settings.component.ts